import {ToastNotificationServiceName} from "./names/serviceNames";
import {ToastNotificationService} from "./ToastNotificationService";
import {IHttpService, IPromise, IRequestConfig} from "angular";

export class HttpResponseService {

    static instance = [
        '$http',
        ToastNotificationServiceName,
        HttpResponseService
    ]

    constructor(private $http: IHttpService,
                private toastNotificationService: ToastNotificationService) {
    }

    executeHttp<T>(itemName: string, config: IRequestConfig): IPromise<T> {
        return this.$http<T>(config)
            .then(resp => this.handleHtppResponse(resp, itemName))
    }


    handleHtppResponse<T>(resp: angular.IHttpResponse<T>, itemName: string) {
        if (this.is2xxSuccessful(resp)) {
            return resp.data;
        } else {
            this.toastNotificationService.generateErrorMessage(`Failed to fetch ${itemName}`);
            throw new Error();
        }
    }

    private is2xxSuccessful<T>(resp: angular.IHttpResponse<T>) {
        return Math.floor(resp.status / 100) === 2;
    }
}